import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import CustomText, { getFontSize, getFontWeight } from "../CustomText";
import "fontsource-muli";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Color from "../../../utils/Color";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import Popover from "@material-ui/core/Popover";
import CustomPaper from "../../components/CustomPaper";
import IconButton from "@material-ui/core/IconButton";
import InfoIcon from "@material-ui/icons/Info";
const CustomTextInput = ({
  classes,
  design,
  title,
  textstyle,
  startAdornment,
  endAdornment,
  onChange = () => { },
  value,
  type,
  placeholder,
  required,
  disabled = false,
  defaultValue,
  autoFocus = false,
  children,
  id = "outlined-input",
  fullWidth = false,
  multiline = false,
  errorMessage = "",
  errorTextStyle,
  notchedOutlineStyle,
  rootStyle,
  error = false,
  borderline,
  tooltip = null,
  borderNone,
  maxLengthFlag,
  success,
  successMessage = '',
  successTextStyle,
  toolTip,
  toolTipText,
  toolTipText2,
  toolTipTexts=[],
  nricDisabled=false,
  ...props
}) => {
  return (
    <div>
      {title ? (
        toolTip ? (
          <span>
            <CustomText
              className={`${classes.textStyle} ${textstyle}`}
              style={{ display: "inline-block" }}
            >
              {title}
            </CustomText>
            <PopupState variant="popover" style={{ display: "inline-block" }}>
              {(popupState) => (
                <span
                  style={{
                    margin: "0",
                    padding: "0",
                  }}
                >
                  <IconButton
                    //onClick={handleClick}
                    style={{
                      marginBottom: "0em",
                      padding: "0",
                      display: "inline",
                      marginTop: "-3px",
                      outline: "none",
                      marginLeft:"4px"
                    }}
                    {...bindTrigger(popupState)}
                  >
                    <InfoIcon className={classes.infoIconStyle} />
                  </IconButton>

                  <Popover
                    {...bindPopover(popupState)}
                    anchorOrigin={{
                      vertical: "center",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "center",
                      horizontal: "left",
                    }}
                  >
                    <CustomPaper
                      style={{
                        minWidth: "200px",
                        maxWidth: "200px",
                      }}
                    >
                      {/* <CustomText
                        style={{
                          fontWeight: "300",
                        }}
                      >
                        {toolTipText}
                      </CustomText>
                      <CustomText
                        style={{
                          fontWeight: "300",
                          marginTop: 8,
                        }}
                      >
                        {toolTipText2}
                      </CustomText> */}
                      {toolTipTexts.map((text, index) => (
                        <CustomText
                          key={index}
                          style={{
                            fontWeight: "300",
                            marginTop: index > 0 ? 8 : 0,
                            fontSize:'13px'
                          }}
                        >
                          {text}
                        </CustomText>
                      ))}
                    </CustomPaper>
                  </Popover>
                </span>
              )}
            </PopupState>
          </span>
        ) : (
          <CustomText
            className={`${classes.textStyle} ${textstyle}`}
            style={{ display: "inline-block" }}
          >
            {title}
          </CustomText>
        )
      ) : (
        false
      )}
      <OutlinedInput
        autoComplete="new-password"
        className={`${classes.root} ${design}`}
        id={id}
        value={value}
        onChange={onChange}
        type={type}
        startAdornment={startAdornment}
        endAdornment={endAdornment}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        defaultValue={defaultValue}
        autoFocus={autoFocus}
        fullWidth={fullWidth}
        multiline={multiline}
        error={error}
        classes={{
          root: !error
            ? `${classes.root}  ${rootStyle}`
            : `${classes.errorRoot}`,
          focused: classes.focused,
          notchedOutline: borderline !== true
            ? `${classes.notchedOutline} ${notchedOutlineStyle}`
            : `${classes.notchedOutlineNone} ${notchedOutlineStyle}`,
          input: nricDisabled ? classes.inputStyleDisabled :error ? classes.inputStyleErr : classes.inputStyle,
        }}
        inputProps={{ maxLength: maxLengthFlag ? 500 : 60 }}
        {...props}
      />
      {error ? (
        <CustomText className={`${classes.errorTextStyle} ${errorTextStyle}`}>
          {errorMessage}
        </CustomText>
      ) : (
        false
      )}
      {success ? (
        <CustomText className={`${classes.successTextStyle} ${successTextStyle}`}>
          {successMessage}
        </CustomText>
      ) : (
        false
      )}
    </div>
  );
};

const styles = {
  root: {
    // marginBottom: 18,
    "& $notchedOutline": {
      borderWidth: 1,
    },
    "& $notchedOutlineV2": {
      borderWidth: 1,
      border: "none",
      backgroundColor: "#f5f5f5"
    },
    "&:hover $notchedOutline": {
      border: "solid 1px",
      borderColor: Color.textInputColor,
    },
    "&$focused $notchedOutline": {
      border: "solid 1px",
      borderColor: Color.textInputColor,
    },
    "& input::placeholder": {
      color: "#303030",
      fontWeight: "bold"
    },
  },
  errorRoot: {
    // marginBottom: 0,
    "& $notchedOutline": {
      borderWidth: 1,
    },
    "&:hover $notchedOutline": {
      border: "solid 1px",
      borderColor: Color.errorBorderColor,
    },
    "&$focused $notchedOutline": {
      border: "solid 1px",
      borderColor: Color.errorBorderColor,
    },
  },
  textStyle: {
    textTransform: "none",
    ...getFontWeight("600"),
    fontFamily: "Muli",
    fontSize: 15,
  },
  buttonStyle: {},
  focused: {},
  notchedOutline: {},
  notchedOutlineNone: {
    //border: 0,
    border: "none",
    backgroundColor: "#F3F3F3",
    opacity: 0.3
  },
  inputStyle: {
    textTransform: "none",
    ...getFontWeight("600"),
    fontFamily: "Muli",
    fontSize: 15,
    color: Color.primaryTextColor,
  },
  inputStyleDisabled: {
    textTransform: "none",
    ...getFontWeight("600"),
    fontFamily: "Muli",
    fontSize: 15,
    color: Color.primaryDisabledColor,
  },
  inputStyleErr: {
    textTransform: "none",
    ...getFontWeight("600"),
    fontFamily: "Muli",
    fontSize: 15,
    color: '#EF4444',
  },
  errorTextStyle: {
    textTransform: "none",
    ...getFontWeight("normal"),
    fontFamily: "Muli",
    ...getFontSize("xxsmall"),
    color: Color.errorBorderColor,
    marginTop: "0.7em",
  },
  successTextStyle: {
    textTransform: "none",
    ...getFontWeight("normal"),
    fontFamily: "Muli",
    ...getFontSize("xxsmall"),
    marginTop: "0.7em",
  },
  tooltipLabelContainer: {
    display: "flex",
    alignItems: "center",

  },
  infoIconStyle:{
    width:'18px',
    height:'18px'
  }
};
export default withStyles(styles)(CustomTextInput);
